<template>
  <div>
    <div
      v-if="aclHelper.getSettingsUpdateAccess()"
      class="row controls"
    >
      <button
        type="button"
        class="btn btn--darkblue"
        @click="openAddBuildingModal()"
      >
        {{ $t("action.add") }}
      </button>
      <button
        v-if="editView"
        v-hkldreset
        type="button"
        class="btn btn--darkblue"
        @click="discardChange()"
      >
        {{ $t("action.cancel") }}
      </button>
      <button
        v-if="editView"
        v-hkldreset
        type="button"
        class="btn btn--orange"
        @click="save()"
      >
        {{ $t("action.save") }}
      </button>
    </div>
    <div
      id="setting-buildings"
      class="table-wrapper"
    >
      <table class="setting-table">
        <thead>
          <th>{{ $t(itemHeaders[0].name) }}</th>
          <th
            v-for="(header, index) in itemHeaders"
            v-show="Math.ceil(index/headerPageSize) === headerPageNum"
            :key="index"
            :class="header.class"
            @click="navToDetail(header.id)"
          >
            <a>
              {{ header.name }} {{ orderbyAttr === header.code ? reverse ? '&#9660;' : '&#9650;' : null }}
              <i
                v-if="header.code != 'username'"
                class="fa fa-external-link"
                aria-hidden="true"
              />
            </a>
          </th>
          <th style="min-width: 120px;">
            <button
              type="button"
              class="btn icon right"
              :disabled="Math.ceil((itemHeaders.length - 1)/headerPageSize) <= headerPageNum"
              @click="headerPageNum += 1"
            >&#9654;</button>
            <button
              type="button"
              class="btn icon right"
              :disabled="headerPageNum<=1"
              @click="headerPageNum -= 1"
            >&#9664;</button>
          </th>
        </thead>
        <tbody>
          <tr>
            <td>
              <input
                v-model="itemHeaders[0].filter"
                type="text"
                @input="clearIndex()"
              >
            </td>
            <td
              :colspan="
                headerPageNum === maxHeaderPageNum
                  ? ((itemHeaders.length - 1) % headerPageSize) + 1
                  : headerPageSize + 1
              "
            />
          </tr>
          <tr
            v-for="(item) in orderedItems"
            :key="item.id"
          >
            <td>
              <a @click="navToUserDetail(item.id)">{{ userName(item) }}</a>
            </td>
            <td
              v-for="(header, index) in itemHeaders"
              v-show="index > 0 && Math.ceil(index/headerPageSize) === headerPageNum"
              :key="index"
            >
              <input
                v-if="editView || item.buildings[header.code]"
                id="checkBox"
                v-model="item.buildings[header.code]"
                v-hkldinput
                type="checkbox"
                :disabled="!editView"
                @click="updateUserBuilding(item.id, header.id, item.buildings[header.code])"
              >
            </td>
            <td />
          </tr>
        </tbody>
      </table>
    </div>
    <AddBuildingModal
      ref="addBuildingModal"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import userHelper from '@/utils/userHelper'
import cookie from '@/utils/cookie'
import { aclHelper } from '@/utils/aclHelper'
import { getBuildings, updateBuildingUsers, getBuildingsUsers } from '@/api/buildings/request'
import { ROUTER_PATHS } from '@/constants/router'
import { systemUserId } from '@/utils/consts'
import AddBuildingModal from './AddBuildingModal'
import { mapActions, mapGetters } from 'vuex'

function getDefaultData () {
  const windowWidth = $(window).width() - 80
  const maxCols = windowWidth > 1024 ? Math.floor(windowWidth / 175) : 5
  const headerPageSize = cookie.get('settingColumnSize') || maxCols
  return {
    loadingTenderTable: false,
    itemHeaders: [
      {
        code: 'username',
        name: 'settings.hklUser',
        filter: '',
      },
    ],
    items: [],
    pendingUserBuilding: {},
    orderbyAttr: 'updateDate',
    reverse: 0,
    editView: false,
    headerPageSize,
    headerPageNum: 1,
    aclHelper,
  }
}

export default {
  name: 'BuildingList',
  components: {
    AddBuildingModal,
  },
  data: getDefaultData,
  computed: {
    ...mapGetters('user', ['currentUser']),
    orderedItems () {
      const filteredResult =
        _.filter(this.items, item => {
          if ((item.username.toString().split('@')[0].toLowerCase().indexOf(this.itemHeaders[0].filter.toLowerCase()) !== -1) ||
            (item.displayName || ' ').toString().toLowerCase().indexOf(this.itemHeaders[0].filter.toLowerCase()) !== -1) {
            return item
          }
        })
      const systemRowRemovedResult = filteredResult.filter(item => item.id !== systemUserId)
      const result = _.orderBy(systemRowRemovedResult, 'displayName')
      return this.reverse ? result.reverse() : result
    },
    maxHeaderPageNum () {
      return Math.max(
        1,
        Math.ceil((this.itemHeaders.length - 1) / this.headerPageSize),
      )
    },
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  async mounted () {
    await this.initPage()
    window.addEventListener('resize', this.handleResize)
    const tableWidth = document.getElementById('setting-buildings').offsetWidth
    this.maxCols = tableWidth > 1024 ? Math.floor((tableWidth - 270) / 132) : 5
    this.headerPageSize = cookie.get('settingColumnSize') || this.maxCols
  },
  methods: {
    ...mapActions('user', ['reloadUser']),
    reset (keep) {
      const def = getDefaultData()
      def[keep] = this[keep]
      Object.assign(this.$data, def)
    },
    sortBy (attr) {
      if (this.orderbyAttr === attr) {
        this.reverse = !this.reverse
      }
      this.orderbyAttr = attr
    },
    initHeader (orderedBuildings) {
      const mergedHeaders = orderedBuildings.reduce((headerDict, building) => {
        headerDict.push({
          code: building.code,
          name: building.code,
          id: building.id,
        })
        return headerDict
      }, this.itemHeaders)
      this.itemHeaders = null
      this.itemHeaders = mergedHeaders
    },
    navToDetail (id) {
      if (id) {
        this.navPage(ROUTER_PATHS.BUILDING_PROFILE, id)
      }
    },
    userName (user) {
      if (user.username) {
        const name = userHelper.getUserName(user.username, user.displayName)
        return name
      }
    },
    navToUserDetail (id) {
      if (id) {
        this.navPage('hkl-user-detail', id)
      }
    },
    navPage (name, id) {
      this.$router.push({
        name,
        params: {
          id,
        },
      })
    },

    clearIndex () {
      this.tablePageNum = 1
    },

    openAddBuildingModal () {
      this.$refs.addBuildingModal.open()
    },

    async createBuilding () {
      const id = 'createBuilding'
      const name = ROUTER_PATHS.BUILDING_PROFILE
      this.$router.push({
        name,
        params: {
          id,
        },
      })
    },

    async initPage () {
      const users = await getBuildingsUsers()

      users.forEach((user) => {
        const buildings = {}
        user.buildings.reduce((buildingDict, building) => {
          buildingDict[building.code] = true
          return buildingDict
        }, buildings)
        user.buildings = buildings
      }, this)

      this.items = users
      const buildings = await getBuildings()
      const orderedBuildings = _.orderBy(buildings, 'code')
      this.initHeader(orderedBuildings)
    },
    discardChange () {
      this.reset()
      this.editView = false
      this.initPage()
    },
    async save () {
      await updateBuildingUsers(this.pendingUserBuilding)
      await this.reloadUser({ adId: this.currentUser.AD_id })
      this.reset()
      this.editView = false
      this.initPage()
    },
    updateUserBuilding (userId, buildingId, val) {
      if (!this.pendingUserBuilding[userId]) {
        this.pendingUserBuilding[userId] = {}
      }
      this.pendingUserBuilding[userId][buildingId] = val
    },
    handleResize () {
      const tableWidth = document.getElementById('setting-buildings')
        .offsetWidth
      this.maxCols =
        tableWidth > 1024 ? Math.floor((tableWidth - 270) / 132) : 5
      this.headerPageSize = cookie.get('settingColumnSize') || this.maxCols
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~styles/settings/style";
.table-wrapper {
  padding: 0 24px 15px 24px;
}
.controls {
  margin-right: 24px;
}
</style>
